window.MAIN = {}

import Data from './generator/_data.es6'
import Canvas from './generator/_canvas.es6'
import Pagination from './generator/_pagination.es6'

MAIN.data = new Data()
MAIN.canvas = new Canvas()
MAIN.pagination = new Pagination()

